<div class="text-center">
    <div class="minclt-sidecompressed" #sidecompressed>
        <div #sidecompressedinformation>
            <ng-content select="[sidecompressed]"></ng-content>
        </div>
    </div>
    <p-button [label]="titlebtn" styleClass="morado minclt-btn" (click)="showInformation()" />
</div>